import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NavbarComponent} from './navbar/navbar.component';
import {FooterComponent} from './footer/footer.component';
import {ButtonbarComponent} from './buttonbar/buttonbar.component';
import {MaterialModule} from '../shared/material/material.module';
import {CommonDialogComponent} from './commondialog/common-dialog.component';
import {ContactusComponent} from './contactus/contactus.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import { MapComponent } from './map/map.component';
import {StateSelectComponent} from './formelements/state-select/state-select.component';
import {CountrySelectComponent} from './formelements/country-select/country-select.component';
import { FormsModule } from '@angular/forms';

import { EndClientSelectComponent } from './formelements/end-client-select/end-client-select.component';
import {AddEndClientsComponent} from '../end-clients/end-clients.component';
import { ManagerSelectComponent } from './formelements/manager-select/manager-select.component';
import {AddManangersComponent} from '../manangers/manangers.component';
import { WorkerSelectComponent } from './formelements/worker-select/worker-select.component';
import { AddWorkersComponent } from '../workers/workers.component';
import { TeamSelectComponent } from './formelements/team-select/team-select.component';
import { FileUploadComponent } from './formelements/file-upload/file-upload.component';
import { AlertMessageComponent } from './formelements/file-upload/alert-message/alert-message.component';
import { CurrencySelectComponent } from './formelements/currency-select/currency-select.component';
import { PayRateSelectComponent } from './formelements/pay-rate-select/pay-rate-select.component';
import { UserLinksComponent } from './navbar/user-links/user-links.component';
import { AllocationSelectComponent } from './formelements/allocation-select/allocation-select.component';
import { ChargeSelectComponent } from './formelements/charge-select/charge-select.component';
import { MultipleFileUploadComponent } from './formelements/multiple-file-upload/multiple-file-upload.component';
import { CountryGuideComponent } from '../country-guides/country-guide/country-guide.component';
import { AssignmentTableComponent } from '../assignments/assignment-table/assignment-table.component';



@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    ButtonbarComponent,
    CommonDialogComponent,
    ContactusComponent,
    MapComponent,
    StateSelectComponent,
    CountrySelectComponent,
    EndClientSelectComponent,
    AddEndClientsComponent,
    ManagerSelectComponent,
    AddManangersComponent,
    WorkerSelectComponent,
    AddWorkersComponent,
    TeamSelectComponent,
    FileUploadComponent,
    AlertMessageComponent,
    CurrencySelectComponent,
    PayRateSelectComponent,
    UserLinksComponent,
    AllocationSelectComponent,
    ChargeSelectComponent,
    MultipleFileUploadComponent,
    CountryGuideComponent,
    AssignmentTableComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
  
  ],
    exports: [
        NavbarComponent,
        FooterComponent,
        ButtonbarComponent,
        CommonDialogComponent,
        ContactusComponent,
        MapComponent,
        CountrySelectComponent,
        ChargeSelectComponent,
        StateSelectComponent,
        EndClientSelectComponent,
        AddEndClientsComponent,
        ManagerSelectComponent,
        AddManangersComponent,
        WorkerSelectComponent,
        AddWorkersComponent,
        TeamSelectComponent,
        FileUploadComponent,
        MultipleFileUploadComponent,
        CurrencySelectComponent,
        PayRateSelectComponent,
        UserLinksComponent,
        AllocationSelectComponent,
        CountryGuideComponent,
        AssignmentTableComponent
    ]
})
export class IwgcommonModule { }
